module.exports = __webpack_public_path__ + "img/sort-za-red.8cd6aaa7.svg";